import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { io } from "socket.io-client";
import Cookies from "js-cookie";
import Auth from "../service/Auth";
import { jwtDecode } from "jwt-decode";
import { CONFIG } from "../helpers/constants";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const authService = new Auth(CONFIG.BASE_URL);
  const [user, setUser] = useState(() => {
    try {
      const storedUser = Cookies.get("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error parsing stored user:", error);
      return null;
    }
  });

  const socket = useRef(null);

  const login = (userData) => {
    Cookies.set("token", userData.token, {
      secure: true, // Only transmit over HTTPS in production
      sameSite: "None", // Required for cross-origin requests
    });
    Cookies.set("user", JSON.stringify(userData));
    setUser(userData);
    connectToSocket(userData.token);
  };

  const logout = async () => {
    // await authService.logoutAPICall()
    Cookies.remove("user");
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    if (socket.current) {
      socket.current.disconnect();
      socket.current = null;
    }
    setUser(null);
  };

  const updateUser = (updatedData) => {
    setUser((prevUser) => {
      const updatedUser = { ...prevUser, ...updatedData };

      Cookies.set("user", JSON.stringify(updatedUser), {
        secure: true, // Only transmit over HTTPS in production
        sameSite: "None", // Required for cross-origin
      });

      return updatedUser;
    });
  };

  const connectToSocket = useCallback((token) => {
    if (socket.current) return;

    socket.current = io("https://api.gastonbet365.com", {
      auth: { token },
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socket.current.on("connect", () => {
      socket.current.emit("subscribeToBalanceUpdates", { token });
    });

    socket.current.on("balance", (data) => {
      updateUser({ balance: data.balance });
    });

    socket.current.on("balanceUpdate", (data) => {
      updateUser({ balance: data.balance });
    });
    socket.current.on("forceLogout", (data) => {
      const decoded = jwtDecode(token);
      // console.log(decoded?.id,"User ID From TOKEN")
      // console.log(decoded?.sessionId, "User session ID From TOKEN")
      // console.log(data.userId, "User ID From Socket")
      // console.log(data.oldSessionId, "User old session ID From Socket")
      if (
        data.userId === decoded.id &&
        decoded.sessionId === data.oldSessionId
      ) {
        logout();
        window.location.reload();
      }
    });

    socket.current.on("disconnect", (reason) => {});
  }, []);
  useEffect(() => {
    if (user && user.token) {
      connectToSocket(user.token);
    }
    return () => {
      if (socket.current) {
        socket.current.disconnect();
        socket.current = null;
      }
    };
  }, [user, connectToSocket]);

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
